import React from 'react';
import PageHeader from '../../../../components/common/PageHeader';

import { LB_KPI_MODULE } from '../../../../utils/constant/labels';

const { LB_KPI_HEADER_TITLE } = LB_KPI_MODULE;

const KPITools = () => {
  return <PageHeader headerTitle={LB_KPI_HEADER_TITLE} />;
};

export default KPITools;
